import { render, staticRenderFns } from "./u-card-outlined-rounded.vue?vue&type=template&id=23e8e972&scoped=true&"
import script from "./u-card-outlined-rounded.vue?vue&type=script&lang=js&"
export * from "./u-card-outlined-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8e972",
  null
  
)

export default component.exports